var map = {
	"./2024-01-12_1.jpg": 6057,
	"./2024-01-12_2.jpg": 2974,
	"./2024-01-12_3.mp4": 6170,
	"./2024-01-12_4.mp4": 1297,
	"./2024-01-12_5.mp4": 668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8174;